var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame58(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "User",
    d: "M2.96582 16.156V15.0063C3.00928 14.1526 3.52245 13.3934 4.29839 13.0349C7.95746 11.5651 12.0428 11.5651 15.7018 13.0349C16.4778 13.3934 16.9909 14.1526 17.0344 15.0063V16.156C17.0341 16.7784 16.7864 17.3751 16.3459 17.8147C15.9054 18.2544 15.3082 18.5009 14.6858 18.5H5.31439C4.69203 18.5009 4.09482 18.2544 3.65431 17.8147C3.2138 17.3751 2.96612 16.7784 2.96582 16.156ZM10.0001 2.5C8.41913 2.49954 6.99357 3.45154 6.38824 4.91203C5.78291 6.37253 6.11703 8.05386 7.23478 9.17195C8.35254 10.29 10.0338 10.6246 11.4944 10.0197C12.9551 9.41482 13.9075 7.98955 13.9075 6.40857C13.9078 5.37206 13.4963 4.3779 12.7635 3.64486C12.0307 2.91183 11.0366 2.5 10.0001 2.5Z",
    fill: "currentColor"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame58);
export default __webpack_public_path__ + "static/media/Frame (58).cf5637ab15cebcd4d5a463c8aeb7fbf5.svg";
export { ForwardRef as ReactComponent };